import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryShowcase from './components/CategoryShowcase';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from '@/components/base/FAQSection';
import NewsletterCTA from '@/components/base/NewsletterCTA';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <article>
          <HeroSection />
          <CategoryShowcase />
          <FeaturedArticles />
          <FAQSection />
          <NewsletterCTA />
        </article>
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '我刚刚结婚两个月，为什么感觉婚姻生活和我想象的完全不一样？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '这种感觉非常正常！几乎每一对新婚夫妻都会经历从"恋爱模式"到"婚姻模式"的过渡期。给自己和对方3-6个月的适应期，不要急于给婚姻下结论。',
                },
              },
              {
                '@type': 'Question',
                name: '婚后怎么处理婆媳关系？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '婆媳关系的核心是"边界"——不是筑墙，而是建立健康的互动规则。建议分三步走：和丈夫达成共识、温和坚定地表达自主权、主动创造温馨相处时刻。',
                },
              },
              {
                '@type': 'Question',
                name: '婚后如何保持自己的独立魅力？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '保持独立魅力的核心是"持续成长"。关注六个投资方向：职业能力、社交圈、身体健康、深度爱好、阅读思考、独处能力。',
                },
              },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '第一次人妻完全指南——新婚妻子必看的生活智慧',
            description: '为初为人妻的女性提供婚姻生活、家庭经营、夫妻沟通与自我成长的实用建议',
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://firstwife.guide/',
                },
              ],
            },
          }),
        }}
      />
    </>
  );
}